import { useContext } from 'react'
import { QuestaoDeOrdemContext } from './ProviderQuestaoDeOrdem'

export default function useFindQuestaoDeOrdem(streamId) {
  const { users } = useContext(QuestaoDeOrdemContext)

  const myUser = users.find((u) => u.streamId === streamId)
  return myUser
}
